import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar, HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-alert-light/30" data-id="element-108">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-110">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-alert-light text-alert font-bold text-sm mb-4" data-id="element-111">
            <span className="w-2 h-2 rounded-full bg-alert animate-pulse" data-id="element-112"></span>
            Alerta · Costo oculto
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-113">
            Dejá de pagar con tu tiempo libre.
          </h2>
          <p className="text-xl text-gray-600" data-id="element-114">
            El verdadero costo oculto de improvisar la consulta:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-116">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-117">
              <Clock className="w-8 h-8 text-alert" data-id="element-118" />
            </div>
            <h3 className="text-3xl font-black text-alert mb-2" data-id="element-119">+100hrs</h3>
            <p className="text-gray-900 font-bold mb-1" data-id="element-120">Perdidas al año</p>
            <p className="text-gray-500 text-sm" data-id="element-121">de tu vida personal</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-122">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-123">
              <Calendar className="w-8 h-8 text-alert" data-id="element-124" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-125">
              2 a 4 horas por semana
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-126">
              armando materiales y explicaciones a mano.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-127">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-128">
              <HeartCrack className="w-8 h-8 text-alert" data-id="element-129" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-130">
              Fines de semana, noches y familia
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-131">tiempo que ya no vuelve.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}